module.exports = __webpack_public_path__ + "img/denisse-image.9ee57065.jpeg";